import styled from 'styled-components';
export const Container = styled.div `
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    justify-content: space-between;
    position: relative;
    width: 100%;
`;
Container.displayName = 'Container';
export const HorizontalContainer = styled(Container) `
    flex-direction: row;
`;
HorizontalContainer.displayName = 'HorizontalContainer';
//# sourceMappingURL=index.js.map